import React from 'react';
import TinySlider from "tiny-slider-react";
import 'tiny-slider/dist/tiny-slider.css';
import './index.css';
import img01Gal1 from 'assets/galerias/galeria-1/img-01.jpg';
import img02Gal1 from 'assets/galerias/galeria-1/img-02.jpg';
import img03Gal1 from 'assets/galerias/galeria-1/img-03.jpg';
import img04Gal1 from 'assets/galerias/galeria-1/img-04.jpg';
import img05Gal1 from 'assets/galerias/galeria-1/img-05.jpg';
import img06Gal1 from 'assets/galerias/galeria-1/img-06.jpg';
import img07Gal1 from 'assets/galerias/galeria-1/img-07.jpg';
import img08Gal1 from 'assets/galerias/galeria-1/img-08.jpg';
import img09Gal1 from 'assets/galerias/galeria-1/img-09.jpg';
import img10Gal1 from 'assets/galerias/galeria-1/img-10.jpg';
import img11Gal1 from 'assets/galerias/galeria-1/img-11.jpg';
import img12Gal1 from 'assets/galerias/galeria-1/img-12.jpg';
import img13Gal1 from 'assets/galerias/galeria-1/img-13.jpg';
import img14Gal1 from 'assets/galerias/galeria-1/img-14.jpg';
import img15Gal1 from 'assets/galerias/galeria-1/img-15.jpg';
import img16Gal1 from 'assets/galerias/galeria-1/img-16.jpg';
import img17Gal1 from 'assets/galerias/galeria-1/img-17.jpg';
import img18Gal1 from 'assets/galerias/galeria-1/img-18.jpg';
import img19Gal1 from 'assets/galerias/galeria-1/img-19.jpg';

import img01Gal2 from 'assets/galerias/galeria-2/img-01.jpg';
import img02Gal2 from 'assets/galerias/galeria-2/img-02.jpg';
import img03Gal2 from 'assets/galerias/galeria-2/img-03.jpg';
import img04Gal2 from 'assets/galerias/galeria-2/img-04.jpg';
import img05Gal2 from 'assets/galerias/galeria-2/img-05.jpg';

import img01Gal3 from 'assets/galerias/galeria-3/img-01.jpg';
import img02Gal3 from 'assets/galerias/galeria-3/img-02.jpg';
import img03Gal3 from 'assets/galerias/galeria-3/img-03.jpg';
import img04Gal3 from 'assets/galerias/galeria-3/img-04.jpg';
import img05Gal3 from 'assets/galerias/galeria-3/img-05.jpg';
import img06Gal3 from 'assets/galerias/galeria-3/img-06.jpg';
import img07Gal3 from 'assets/galerias/galeria-3/img-07.jpg';
import img08Gal3 from 'assets/galerias/galeria-3/img-08.jpg';
import img09Gal3 from 'assets/galerias/galeria-3/img-09.jpg';
import img10Gal3 from 'assets/galerias/galeria-3/img-10.jpg';


const galerias = {
  numeros: [
    img01Gal1,
    img02Gal1,
    img03Gal1,
    img04Gal1,
    img05Gal1,
    img06Gal1,
    img07Gal1,
    img08Gal1,
    img09Gal1,
    img10Gal1,
    img11Gal1,
    img12Gal1,
    img13Gal1,
    img14Gal1,
    img15Gal1,
    img16Gal1,
    img17Gal1,
    img18Gal1,
    img19Gal1,
  ],
  incluir: [
    img01Gal2,
    img02Gal2,
    img03Gal2,
    img04Gal2,
    img05Gal2
  ],
  movimiento: [
    img01Gal3,
    img02Gal3,
    img03Gal3,
    img04Gal3,
    img05Gal3,
    img06Gal3,
    img07Gal3,
    img08Gal3,
    img09Gal3,
    img10Gal3,
  ]
}

const settings = {
  // loop: true,
  // autoplayHoverPause: true,
  lazyload: true,
  nav: false,
  mouseDrag: true,
  items: 1,
  gutter: 25,
  controls: false,
  autoplayButton: false,
  speed: 300,
  autoplay: true,
  edgePadding: 15,
  autoplayTimeout: 2500,
  autoHeight: true,
  responsive: {
    420: {
      items: 2
    },
    768: {
      items: 3
    }
  }
};

function ImageSlider({galeria}) {
  return (
    <div className="imageslider tns-gallery">
      <TinySlider settings={settings}>
        {galerias[galeria].map((el, index) => (
          <div key={index}>
            <span>
              <img
                className={`tns-lazy-img`}
                data-src={el}
                alt=""
              />
            </span>
          </div>
        ))}
      </TinySlider>
    </div>
  );
}

export default ImageSlider;
